import { gameState } from '../state/gameState.js';
import { placeMode } from './PlaceMode.js';
import { SCENE_TO_BACKEND, FURNITURE_SCENES, GAME_HEIGHT } from '../config.js';
import { isTouchDevice } from './isTouchDevice.js';
import { gameButton } from './gameUi.js';
import { houseStorageItems } from './houseStorage.mjs';
import { openHouseStorage } from './HouseStorage.js';
import { pinToCamera } from './pin.mjs';

// What you own but haven't placed here: one wooden "Schowek (n)" button, like the farm's, that opens
// the Schowek panel (owner 2026-10-03: the cards used to sit along the bottom all the time). Hidden
// when there is nothing to place.
export class PlacementHud {
  constructor(scene) {
    this.scene = scene;
    this.container = scene.add.container(0, 0).setDepth(800);
    this._gen = 0;
    this._unsub = gameState.on(() => this.refresh());
    scene.events.on('shutdown', () => { this._unsub?.(); placeMode.exit(); });
    this.refresh();
  }

  refresh() {
    this.container.removeAll(true);
    const backendScene = SCENE_TO_BACKEND[this.scene.scene.key];
    const items = houseStorageItems(gameState.raw, backendScene, { furniture: FURNITURE_SCENES.has(backendScene) });
    if (!items.length) return;
    const n = items.reduce((s, i) => s + i.count, 0);
    // Phones: right of the joystick, which covers the bottom-left corner.
    const touch = isTouchDevice();
    const w = 190, x = (touch ? 280 : 30) + w / 2, y = GAME_HEIGHT - 40;
    const btn = gameButton(this.scene, x, y, w, 48, `{crate} Schowek (${n})`, () => {
      openHouseStorage(this.scene, items, { onPick: (it) => placeMode.enterPlace(this.scene, it.type, it.item) });
    }, { variant: 'wood', fontSize: 17 });
    this.container.add(btn);
    pinToCamera(this.container);   // stays on screen (and clickable) in a scrolling scene — the wide Podwórko
  }
}
